<template>
  <div module-item :class="info.type">
    <ul>
      <li v-for="(row, i) in info.value" :key="i" :class="row.award">
        <p v-html="enterToBr(row.text)"></p>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'Award',
  props: ['value'],
  computed: {
    info() {
      return this.value;
    },
  },
};
</script>

